import { createReducer, on } from '@ngrx/store';
import { recalculateActions } from './recalculate.actions';
import { RecalculateState, initialRecalculateState } from './recalculate.state';

export const recalculateReducer = createReducer(
  initialRecalculateState,

  // Reset
  on(recalculateActions.reset, (): RecalculateState => initialRecalculateState),

  // Fetch Recap
  on(
    recalculateActions.fetchRecap,
    (state): RecalculateState => ({
      ...state,
      loading: { ...state.loading, fetchRecap: true, generateRecap: false },
      error: { ...state.error, fetchRecap: null }
    })
  ),
  on(
    recalculateActions.fetchRecapSuccess,
    (state, { recap }): RecalculateState => ({
      ...state,
      recap,
      loading: { ...state.loading, fetchRecap: false, generateRecap: false }
    })
  ),
  on(
    recalculateActions.fetchRecapNotFound,
    (state): RecalculateState => ({
      ...state,
      loading: { ...state.loading, fetchRecap: false, generateRecap: false }
    })
  ),
  on(
    recalculateActions.fetchRecapFailure,
    (state, { error }): RecalculateState => ({
      ...state,
      loading: { ...state.loading, fetchRecap: false, generateRecap: false },
      error: { ...state.error, fetchRecap: error }
    })
  ),

  // Generate Recap
  on(
    recalculateActions.generateRecap,
    (state): RecalculateState => ({
      ...state,
      loading: { ...state.loading, generateRecap: true, fetchRecap: false },
      error: { ...state.error, generateRecap: null }
    })
  ),
  on(
    recalculateActions.generateRecapSuccess,
    (state, { recap }): RecalculateState => ({
      ...state,
      recap,
      loading: { ...state.loading, generateRecap: false, fetchRecap: false }
    })
  ),
  on(
    recalculateActions.generateRecapFailure,
    (state, { error }): RecalculateState => ({
      ...state,
      loading: { ...state.loading, generateRecap: false, fetchRecap: false },
      error: { ...state.error, generateRecap: error }
    })
  ),

  // Subscription Nutrigenetic Plus Process
  on(
    recalculateActions.initiateSubscriptionNutrigeneticPlusProcess,
    (state): RecalculateState => ({
      ...state,
      loading: {
        ...state.loading,
        initiateSubscriptionNutrigeneticPlusProcess: true
      },
      error: {
        ...state.error,
        initiateSubscriptionNutrigeneticPlusProcess: null
      }
    })
  ),
  on(
    recalculateActions.initiateSubscriptionNutrigeneticPlusProcessSuccess,
    (state, { response }): RecalculateState => ({
      ...state,
      nutrigeneticPlusGuidelineUpdated: response,
      loading: {
        ...state.loading,
        initiateSubscriptionNutrigeneticPlusProcess: false
      },
      error: {
        ...state.error,
        initiateSubscriptionNutrigeneticPlusProcess: null
      }
    })
  ),
  on(
    recalculateActions.initiateSubscriptionNutrigeneticPlusProcessFailure,
    (state, { error }): RecalculateState => ({
      ...state,
      loading: {
        ...state.loading,
        initiateSubscriptionNutrigeneticPlusProcess: false
      },
      error: {
        ...state.error,
        initiateSubscriptionNutrigeneticPlusProcess: error
      }
    })
  ),

  // Generation Nourish Plus Execute
  on(
    recalculateActions.generationNourishPlusExecute,
    (state): RecalculateState => ({
      ...state,
      loading: {
        ...state.loading,
        generationNourishPlusExecute: true
      },
      error: {
        ...state.error,
        generationNourishPlusExecute: null
      }
    })
  ),
  on(
    recalculateActions.generationNourishPlusExecuteSuccess,
    (state): RecalculateState => ({
      ...state,
      loading: {
        ...state.loading,
        generationNourishPlusExecute: false
      },
      error: {
        ...state.error,
        generationNourishPlusExecute: null
      }
    })
  ),
  on(
    recalculateActions.generationNourishPlusExecuteFailure,
    (state, { error }): RecalculateState => ({
      ...state,
      loading: {
        ...state.loading,
        generationNourishPlusExecute: false
      },
      error: {
        ...state.error,
        generationNourishPlusExecute: error
      }
    })
  )
);
